import { render, staticRenderFns } from "./story_form.vue?vue&type=template&id=5bebf6c8&scoped=true&lang=pug"
import script from "./story_form.vue?vue&type=script&lang=js"
export * from "./story_form.vue?vue&type=script&lang=js"
import style0 from "./story_form.vue?vue&type=style&index=0&id=5bebf6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebf6c8",
  null
  
)

export default component.exports